export default "__VITE_ASSET__BUEwEVSR__"